module.exports = __webpack_public_path__ + "static/media/escortsKubota.e3a6d942.svg";